'use client';
import Image from 'next/image';
import not_found from '../public/images/not-found.svg';

import { Button } from "@nextui-org/react";
import { useRouter } from "next/navigation";
 
export default function NotFound() {
	const router = useRouter();

	return (
		<div className="flex">
			<div className="mx-auto mr-0">
				<Image
					src={not_found}
					className="w-[83%]"
					height={100}
					width={83}
					alt='Error 404 Logo'
				/>
			</div>
			<div className="flex flex-col justify-center mx-auto -ml-[32%]">
				<span className="mb-3 text-4xl font-medium">Page Not Found</span>
				<span className="mb-8 text-base font-normal">It seems we can’t find the page you are looking for</span>
				<div className="flex items-center gap-7">
					<Button
						variant="solid"
						color="primary"
						size="md"
						radius="sm"
						onClick={router.back}
					>Go Back</Button>
					<Button
						variant="ghost"
						color="primary"
						size="md"
						radius="sm"
						onClick={() => router.push('/')}
					>Go To Homepage</Button>
				</div>
			</div>
		</div>
	)
}
